var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8H18.46C18.8125 7.39232 18.9988 6.70252 19 6C19 4.34315 17.6569 3 16 3C14.3773 3.19863 12.9192 4.08803 12 5.44C11.0808 4.08803 9.62275 3.19863 8 3C6.34315 3 5 4.34315 5 6C5.00125 6.70252 5.18749 7.39232 5.54 8H5C3.89543 8 3 8.89543 3 10V13C3 13.5523 3.44772 14 4 14H5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V14H20C20.5523 14 21 13.5523 21 13V10C21 8.89543 20.1046 8 19 8ZM16 5C16.5523 5 17 5.44772 17 6C17.001 6.66525 16.6712 7.28746 16.12 7.66C15.7889 7.88249 15.3989 8.00089 15 8H13C13 6.91 14.91 5 16 5ZM8 5C7.44772 5 7 5.44772 7 6C7 7.10457 7.89543 8 9 8H11C11 6.91 9.09 5 8 5ZM11 10V12H5V10H11ZM11 19V14H7V19H11ZM13 19V14H17V19H13ZM13 10V12H19V10H13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.db3171348036ed28d642042912549d2a.svg";
export { ForwardRef as ReactComponent };